/* PFF product page v2 */
(function () {
  var root = document.querySelector('.pff-pdp');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (d) { return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); };

  /* ---------- gallery ---------- */
  var track = $('.pff-track');
  var imgs = track ? $$('img', track) : [];
  var thumbs = $$('.pff-thumbs button');
  var dots = $$('.pff-dots span');
  var counter = $('.pff-counter:not(.pff-lb-count)');
  var current = 0;
  function setActive(i) {
    current = i;
    thumbs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
    dots.forEach(function (d, j) { d.classList.toggle('on', j === i); });
    if (counter) counter.textContent = (i + 1) + ' / ' + imgs.length;
  }
  if (track) {
    if (counter) counter.textContent = '1 / ' + imgs.length;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== current) setActive(Math.min(Math.max(i, 0), imgs.length - 1));
      });
    }, { passive: true });
    thumbs.forEach(function (t, j) {
      t.addEventListener('click', function () { track.scrollTo({ left: j * track.clientWidth, behavior: 'smooth' }); setActive(j); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        var n = Math.min(Math.max(current + (e.key === 'ArrowRight' ? 1 : -1), 0), imgs.length - 1);
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); setActive(n);
      }
    });
  }

  /* ---------- dialogs ---------- */
  function openDialog(d) { if (!d) return; if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); }
  function closeDialog(d) { if (!d) return; if (d.close) d.close(); else d.removeAttribute('open'); }
  $$('[data-pff-open]').forEach(function (b) {
    b.addEventListener('click', function () { openDialog(document.getElementById(b.getAttribute('data-pff-open'))); });
  });
  $$('dialog', root).forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d && !d.classList.contains('pff-lightbox')) closeDialog(d);
      if (e.target.closest('[data-pff-close]')) closeDialog(d);
    });
  });

  /* lightbox */
  var lb = $('.pff-lightbox');
  var lbTrack = $('.pff-lb-track');
  var lbCount = $('.pff-lb-count');
  if (lb && lbTrack && imgs.length) {
    imgs.forEach(function (im) {
      var c = document.createElement('img');
      c.alt = im.alt; c.loading = 'lazy';
      c.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2000');
      lbTrack.appendChild(c);
      im.addEventListener('click', function () {
        openDialog(lb);
        var i = Number(im.getAttribute('data-index')) || imgs.indexOf(im);
        lbTrack.scrollLeft = i * lbTrack.clientWidth;
        lbCount.textContent = (i + 1) + ' / ' + imgs.length;
      });
    });
    lbTrack.addEventListener('scroll', function () {
      var i = Math.round(lbTrack.scrollLeft / Math.max(lbTrack.clientWidth, 1));
      lbCount.textContent = (i + 1) + ' / ' + imgs.length;
    }, { passive: true });
  }

  /* ---------- variants (multi-size listings) ---------- */
  var product = {};
  try { product = JSON.parse($('[data-pff-product-json]').textContent); } catch (e) {}
  var variantInput = $('[data-pff-variant-input]');
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var currentVariant = (product.variants || []).filter(function (v) { return variantInput && String(v.id) === variantInput.value; })[0];
  $$('.pff-pills').forEach(function (group) {
    var pos = Number(group.getAttribute('data-option-position')) - 1;
    $$('button', group).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('button', group).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
        var opts = (currentVariant ? currentVariant.options.slice() : []);
        opts[pos] = btn.getAttribute('data-value');
        var match = (product.variants || []).filter(function (v) {
          return v.options.every(function (o, k) { return o === opts[k]; });
        })[0] || (product.variants || []).filter(function (v) { return v.options[pos] === opts[pos]; })[0];
        if (match) setVariant(match);
      });
    });
  });
  function setVariant(v) {
    currentVariant = v;
    if (variantInput) variantInput.value = v.id;
    $$('[data-pff-price]').forEach(function (el) { el.textContent = money(v.price); });
    var rrp = $('[data-pff-rrp]');
    if (rrp) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        rrp.hidden = false;
        $('[data-pff-compare]').textContent = money(v.compare_at_price);
        $('[data-pff-save]').textContent = 'You save ' + money(v.compare_at_price - v.price);
      } else rrp.hidden = true;
    }
    var sizeNow = document.querySelector('[data-pff-size-now]');
    var sizeIdx = (product.options || []).map(function (o) { return String(o.name || o).toLowerCase(); }).indexOf('size');
    if (sizeNow && sizeIdx > -1) sizeNow.textContent = v.options[sizeIdx];
    highlightSize();
    var add = $('.xb-wishlist__add'); if (add) add.setAttribute('xb-product-variant', v.id);
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    updateSticky();
  }

  /* size table highlight */
  function highlightSize() {
    var tbl = document.querySelector('[data-pff-size-table]');
    var now = document.querySelector('[data-pff-size-now]');
    if (!tbl || !now) return;
    var s = now.textContent.trim();
    $$('tr', tbl).forEach(function (tr) {
      var cells = $$('td', tr).map(function (td) { return td.textContent.trim(); });
      var hit = cells.some(function (c) {
        if (c === s) return true;
        var m = c.match(/^(\d+)\s*[–-]\s*(\d+)$/);
        return m && Number(s) >= Number(m[1]) && Number(s) <= Number(m[2]) && cells.indexOf(c) === 1;
      });
      tr.classList.toggle('pff-hl', hit);
    });
  }
  highlightSize();

  /* ---------- izyrent booking calendar ---------- */
  var form = $('.pff-form form');
  var addBtn = form ? form.querySelector('[name="add"]') : null;
  var datesBox = $('.pff-dates');
  var timeline = $('[data-pff-timeline]');
  var stickyDate = $('[data-pff-sticky-date]');
  var stickyCta = $('[data-pff-sticky-cta]');
  var picked = null;
  var hireDays = parseInt(root.getAttribute('data-hire-days'), 10) || 4;

  function readDates() {
    var s = document.getElementById('startDate');
    if (!s) return null;
    var fp = s._flatpickr;
    var dates = fp && fp.selectedDates ? fp.selectedDates.slice() : [];
    if (!dates.length) return null;
    var start = dates[0];
    var end = dates[dates.length - 1];
    if (dates.length === 1) {
      var e = document.getElementById('endDate');
      var ed = e && e._flatpickr && e._flatpickr.selectedDates && e._flatpickr.selectedDates[0];
      if (!ed && e && e.value) { var pe = new Date(e.value); if (!isNaN(pe)) ed = pe; }
      if (ed) end = ed;
      else if (!e || (addBtn && !addBtn.disabled)) {
        /* single-date mode: the hire runs for a fixed number of days */
        end = new Date(start.getTime()); end.setDate(end.getDate() + hireDays);
      } else return { start: start, end: null };
    }
    return { start: start, end: end };
  }
  function ctaLabel(t) {
    if (!addBtn) return;
    var span = addBtn.querySelector('[data-pff-cta-text]') || addBtn.querySelector('.add-to-cart__text');
    if (span) { if (span.textContent !== t) span.textContent = t; }
    else if (!addBtn.querySelector('.waitloader') && addBtn.textContent.trim() !== t) addBtn.textContent = t;
  }
  function sizeLabel() {
    var idx = (product.options || []).map(function (o) { return String(o.name || o).toLowerCase(); }).indexOf('size');
    return currentVariant && idx > -1 ? 'AU ' + currentVariant.options[idx] + ' · ' : '';
  }
  function updateSticky() {
    if (!stickyDate) return;
    if (picked && picked.end) {
      stickyDate.textContent = sizeLabel() + fmt(picked.start) + ' – ' + fmt(picked.end);
      stickyCta.textContent = 'Request to book';
    } else {
      stickyDate.textContent = sizeLabel() + 'Pick a start date';
      stickyCta.textContent = 'Choose date';
    }
  }
  var lastKey = '';
  function sync() {
    var d = readDates();
    var key = d ? d.start.toDateString() + '|' + (d.end ? d.end.toDateString() : '') : '';
    var available = !(addBtn && addBtn.hasAttribute('data-pff-soldout'));
    if (key !== lastKey) {
      lastKey = key;
      picked = d && d.end ? d : null;
      root.classList.toggle('has-dates', !!picked);
      if (timeline) {
        if (picked) {
          timeline.hidden = false;
          $('[data-pff-arrive]').textContent = fmt(picked.start);
          $('[data-pff-return]').textContent = fmt(picked.end);
        } else timeline.hidden = true;
      }
      if (datesBox && picked) datesBox.classList.remove('attn');
      updateSticky();
    }
    if (available && !(form && form.dataset.pffBusy)) ctaLabel(picked ? 'Request to book · ' + fmt(picked.start) : 'Choose a start date');
  }
  if (addBtn && addBtn.textContent.indexOf('unavailable') > -1) addBtn.setAttribute('data-pff-soldout', '');
  setInterval(sync, 400);
  document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('izyDate')) setTimeout(sync, 30); }, true);

  /* Save the date as soon as it is tapped (single-date hires), so the Save button
     at the bottom of the phone calendar can never be missed or covered */
  document.addEventListener('click', function (e) {
    var day = e.target && e.target.closest && e.target.closest('.izyCal .flatpickr-day');
    if (!day || day.classList.contains('flatpickr-disabled')) return;
    setTimeout(function () {
      var s = document.getElementById('startDate'); var fp = s && s._flatpickr;
      if (!fp || fp.config.mode !== 'single' || !fp.selectedDates.length) return;
      var sv = document.querySelector('.izyCal.open .izysave');
      if (sv && sv.offsetParent) sv.click();
      setTimeout(sync, 60);
    }, 200);
  }, true);
  function openCalendar() {
    if (datesBox) {
      datesBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      datesBox.classList.add('attn');
    }
    var tries = 0, note = null;
    (function attempt() {
      var s = document.getElementById('startDate');
      var vis = root.querySelector('#izyrent input.izyDate:not([type=hidden])');
      if ((s && s._flatpickr) || (vis && vis.offsetParent)) {
        if (note) note.remove();
        if (s && s._flatpickr) s._flatpickr.open(); else { vis.focus(); vis.click(); }
        return;
      }
      /* calendar app still loading: say so, then open it as soon as it is ready */
      if (!note && datesBox) {
        note = document.createElement('p'); note.className = 'pff-cal-loading pff-small'; note.setAttribute('role', 'status');
        note.innerHTML = '<span class="pff-spin" aria-hidden="true"></span> Loading the booking calendar\u2026';
        datesBox.appendChild(note);
      }
      if (++tries < 60) setTimeout(attempt, 300);
      else if (note) note.textContent = 'The calendar is taking a while. Please refresh the page, or message us and we\u2019ll book it for you.';
    })();
  }
  /* a disabled submit button swallows clicks, so catch them on the form */
  if (form) {
    form.addEventListener('click', function (e) {
      if (!addBtn || !addBtn.disabled) return;
      var r = addBtn.getBoundingClientRect();
      if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom && !picked) openCalendar();
    });
    var style = document.createElement('style');
    style.textContent = '.pff-pdp .pff-form [name="add"][disabled]{pointer-events:none}';
    document.head.appendChild(style);
  }

  /* ---------- fast add to cart ----------
     The booking app waits 3s on a plain form submit before adding.
     Posting the form ourselves goes through its fetch hook straight away. */
  if (form) {
    var fastAdd = function (e) {
      if (e.type === 'submit' && e.target !== form) return;
      if (e.type === 'click' && !(e.target && e.target.closest && e.target.closest('[name="add"]') === addBtn)) return;
      if (!picked || !addBtn || addBtn.disabled) return;
      if (form.dataset.pffBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      e.preventDefault(); e.stopImmediatePropagation();
      form.dataset.pffBusy = '1';
      var label = addBtn.querySelector('[data-pff-cta-text]') || addBtn, prev = label.textContent;
      addBtn.classList.add('is-busy'); addBtn.setAttribute('aria-busy', 'true'); label.textContent = 'Checking your dates\u2026';
      var stage1 = setTimeout(function () { label.textContent = 'Adding to your bag\u2026'; }, 1500);
      var stage2 = setTimeout(function () { label.textContent = 'Almost there\u2026'; }, 5000);
      var done_ = false;
      /* safety net: if the booking app is slow to answer, check the bag ourselves */
      var guard = setTimeout(function () {
        if (done_) return;
        fetch(root_ + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          if (done_) return;
          if (c && c.items && c.items.some(function (i) { return String(i.variant_id) === vid; })) { done_ = true; window.location.href = root_ + 'cart'; }
          else { label.textContent = 'Still working\u2026 tap again if nothing happens'; delete form.dataset.pffBusy; }
        }).catch(function () {});
      }, 15000);
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var fd = new FormData(form);
      var cv = currentVariant;
      var vid = String(fd.get ? fd.get('id') : '');
      if (cv && cv.compare_at_price && cv.compare_at_price > cv.price) fd.set('properties[You save]', money(cv.compare_at_price - cv.price) + ' vs RRP ' + money(cv.compare_at_price));
      fetch(root_ + 'cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Could not add');
          done_ = true; clearTimeout(guard); label.textContent = 'Opening your bag\u2026';
          window.location.href = root_ + 'cart';
        })
        .catch(function (err) {
          if (done_) return;
          clearTimeout(stage1); clearTimeout(stage2); clearTimeout(guard);
          delete form.dataset.pffBusy; addBtn.classList.remove('is-busy'); addBtn.removeAttribute('aria-busy'); label.textContent = prev;
          var msg = root.querySelector('[data-pff-atc-error]');
          if (!msg) { msg = document.createElement('p'); msg.className = 'pff-atc-error pff-small'; msg.setAttribute('data-pff-atc-error', ''); msg.setAttribute('role', 'alert'); addBtn.insertAdjacentElement('afterend', msg); }
          msg.textContent = (err && err.message && err.message !== 'Could not add' ? err.message + ' ' : '') + 'Please try again, or message us and we\u2019ll book it for you.';
        });
    };
    /* run on window capture so we act before the booking app's own (slower) handlers */
    window.addEventListener('click', fastAdd, true);
    window.addEventListener('submit', fastAdd, true);
  }

  /* ---------- sticky mobile bar ---------- */
  var sticky = $('[data-pff-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    var ctaVisible = true, datesVisible = false, pastTop = false;
    var show = function () {
      var on = pastTop && !ctaVisible && !datesVisible;
      sticky.classList.toggle('show', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      stickyCta.tabIndex = on ? 0 : -1;
      document.body.classList.add('pff-sticky-on');
    };
    if (addBtn) new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; show(); }).observe(addBtn);
    if (datesBox) new IntersectionObserver(function (en) { datesVisible = en[0].isIntersecting; show(); }).observe(datesBox);
    var gallery = $('.pff-gallery');
    if (gallery) new IntersectionObserver(function (en) { pastTop = !en[0].isIntersecting || en[0].boundingClientRect.top < 0; show(); }, { threshold: 0.4 }).observe(gallery);
    stickyCta.addEventListener('click', function () {
      if (picked && addBtn && !addBtn.disabled) addBtn.click();
      else openCalendar();
    });
  }

  /* ---------- reviews link ---------- */
  var revLink = $('[data-pff-reviews-link]');
  if (revLink) revLink.addEventListener('click', function (e) {
    var t = document.querySelector('[id*="reviews_slider"], .reviews-slider, [id*="reviews-slider"]');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* ---------- lender (Webkul) ---------- */
  var BIZ = /\b(hire\w*|rent\w*|collective|wardrobe|closet|boutique|label|studio|styl\w*|fashion|dress\w*|co|pty|ltd|\w*shop\w*|store|designer|outfit|edit|luxe?|club|house|archive|vault|room|lounge|bridal|formal|threads|the|by|of|on|with|and|day|night|date|curat\w*|collection\w*|conscious|love|lend\w*|atelier|basics|available|longer|runway|collins|pff|closet|wear|vintage|designs?|official|au)\b/i;
  var SMALL = /^(of|and|the|by|on|with|for|a|an|in|at|to|x)$/;
  function personName(n) {
    var words = n.split(' ');
    if (BIZ.test(n) || words.length > 3 || /[&@.\d’'!]/.test(n)) return null;
    if (!/^[A-Za-z][a-z-]{2,}$/i.test(words[0])) return null;
    if (n === n.toUpperCase()) return null;
    var first = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
    if (words.length === 1) return first;
    var last = words[words.length - 1];
    if (!/^[A-Za-z]/.test(last)) return first;
    return first + ' ' + last.charAt(0).toUpperCase() + '.';
  }
  function businessName(n) {
    if (/@|https?:|www\.|\d{6,}/i.test(n) || n.length > 40) return null;
    return n.split(' ').map(function (w, i) {
      if (w === w.toLowerCase()) {
        if (i > 0 && SMALL.test(w)) return w;
        return w.charAt(0).toUpperCase() + w.slice(1);
      }
      return w;
    }).join(' ');
  }
  function displayName(n) {
    n = String(n || '').replace(/\s+/g, ' ').trim();
    if (!n) return null;
    var p = personName(n);
    if (p) return { label: p, person: true, first: p.split(' ')[0] };
    var b = businessName(n);
    return b ? { label: b, person: false, first: b } : null;
  }
  function isTop(data) {
    var raw = (root.getAttribute('data-top-lenders') || '').toLowerCase();
    if (!data || !raw) return false;
    var list = raw.split(/[,\n]/).map(function (x) { return x.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
    var keys = [String(data.sp_store_id || ''), String(data.store_name_handle || '').toLowerCase(), String(data.sp_store_name || '').replace(/\s+/g, ' ').trim().toLowerCase()];
    return list.some(function (x) { return keys.indexOf(x) > -1; });
  }
  function lenderHref(data) {
    if (!data || !data.store_name_handle) return null;
    var hereH = (location.pathname.split('/products/')[1] || '').split(/[?#/]/)[0];
    return '/collections/all?view=lender&l=' + btoa(String(data.store_name_handle)).replace(/=+$/,'').replace(/\+/g,'-').replace(/\//g,'_') + '&p=' + encodeURIComponent(root.getAttribute('data-product-id') || '') + '&x=' + encodeURIComponent(hereH);
  }
  function applyLender(data) {
    var dn = data ? displayName(data.sp_store_name) : null;
    if (dn && dn.person) dn = { label: dn.first, person: true, first: dn.first };
    var name = dn ? dn.label : null;
    var label = name || 'Verified lender';
    var href = lenderHref(data);
    $$('[data-pff-lender-name]').forEach(function (el) {
      el.textContent = label;
      if (href && el.closest('.pff-lender-id')) {
        var a = document.createElement('a'); a.href = href; a.className = 'pff-lender-link'; a.textContent = label;
        el.textContent = ''; el.appendChild(a);
      }
    });
    var vb = $('.pff-lender .pff-verified'); if (!name && vb) vb.hidden = true;
    if (name) $$('[data-pff-lender-initial]').forEach(function (el) { el.textContent = name.replace(/[^A-Za-z0-9]/g, '').charAt(0).toUpperCase() || name.charAt(0); });
    var miniEl = $('[data-pff-lender-mini]');
    if (miniEl && data) miniEl.hidden = false;
    $$('[data-pff-profile]').forEach(function (b) { if (href) { b.href = href; b.hidden = false; } });
    if (isTop(data)) {
      $$('[data-pff-top]').forEach(function (el) { el.hidden = false; });
      root.classList.add('is-top-lender');
    }
    var first = dn ? dn.first : null;
    var askT = first ? 'Ask ' + first + ' a question' : 'Ask the lender a question';
    $$('[data-pff-ask-title]').forEach(function (el) { el.textContent = askT; });
    var lf = $('[data-pff-lender-field]', document); if (lf && data) lf.value = data.sp_store_name + ' (store ' + data.sp_store_id + ')';
    var more = $('[data-pff-more]');
    if (more && href) {
      more.href = href; more.textContent = 'View lender profile'; more.hidden = false;
      $$('[data-pff-more-all]').forEach(function (x) { x.href = href; x.hidden = false; });
    }
    if (data && data.store_name_handle) loadMore(data.store_name_handle);
    var rating = $('[data-pff-lender-rating]');
    if (rating && data && Number(data.total_review) > 0 && data.review) {
      rating.innerHTML = '<span class="pff-stars" aria-hidden="true">★</span> <strong>' + Number(data.review).toFixed(1) + '</strong> from ' + data.total_review + ' lender review' + (data.total_review > 1 ? 's' : '');
      rating.hidden = false;
    }
  }
  /* ---------- more from this lender (names stay hidden) ---------- */
  function loadMore(handle) {
    var box = $('[data-pff-lmore]'), track = $('[data-pff-lmore-track]');
    if (!box || !track || loadMore.done) return; loadMore.done = true;
    var here = (location.pathname.split('/products/')[1] || '').split(/[?#/]/)[0];
    var prev = window.getproducts, fin = false;
    window.getproducts = function (html) {
      fin = true; window.getproducts = prev;
      var seen = {}, list = [];
      String(html || '').replace(/href="\/products\/([^"?#]+)"/g, function (m, h) { if (h !== here && !seen[h]) { seen[h] = 1; list.push(h); } return m; });
      list = list.slice(0, 8);
      if (!list.length) return;
      Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        ps = ps.filter(function (p) { return p && p.available !== false && p.featured_image; }).slice(0, 6);
        if (ps.length < 2) return;
        var fmt = function (c) { var v = c / 100; return '$' + (v % 1 ? v.toFixed(2) : v); };
        track.innerHTML = ps.map(function (p) {
          var img = String(p.featured_image).replace(/^\/\//, 'https://');
          img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=360';
          var rrp = p.compare_at_price_min > p.price_min ? ' <s>RRP ' + fmt(p.compare_at_price_min) + '</s>' : '';
          var t = String(p.title).replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; });
          return '<a class="pff-lm" href="/products/' + p.handle + '"><span class="pff-lm__img"><img src="' + img + '" alt="' + t + '" loading="lazy" width="180" height="240"></span><span class="pff-lm__t">' + t + '</span><span class="pff-lm__p">From <strong>' + fmt(p.price_min) + '</strong>' + rrp + '</span></a>';
        }).join('');
        box.hidden = false;
        var mb = $('[data-pff-more]'); if (mb) mb.hidden = false;
      });
    };
    var s = document.createElement('script');
    s.src = 'https://sp-seller.webkul.com/index.php?p=vc_seller_profile&callback=getproducts&shop=' + encodeURIComponent((window.Shopify && Shopify.shop) || 'passin-for-fashion.myshopify.com') +
      '&seller=' + encodeURIComponent(handle) + '&is_preview=0&sp=&pag=&sort_para=4&page_data=16&query=multiple_filter&selected_tag=&cstm_email=false&wk_cust_tag=false&customer_id=&shop_baseurl=&_=' + Date.now();
    s.async = true;
    s.onerror = function () { if (!fin) window.getproducts = prev; };
    document.body.appendChild(s);
  }
  (function loadLender() {
    var pid = root.getAttribute('data-product-id');
    var cb = 'pffLender' + Date.now();
    var done = false;
    window[cb] = function (res) {
      done = true;
      var d = res && res.sellProfileCallback;
      applyLender(d && d.active == 1 ? d : null);
      try { delete window[cb]; } catch (e) { window[cb] = undefined; }
    };
    var s = document.createElement('script');
    s.src = 'https://sp-seller.webkul.com/index.php?p=ajax_seller_profile_tag&shop=' + encodeURIComponent((window.Shopify && Shopify.shop) || 'passin-for-fashion.myshopify.com') +
      '&main_id_product=' + pid + '&request_arr%5B%5D=sellProfileCallback&callback=' + cb;
    s.async = true;
    s.onerror = function () { if (!done) applyLender(null); };
    document.body.appendChild(s);
    setTimeout(function () { if (!done) applyLender(null); }, 6000);
  })();


  /* ---------- every email link on the listing says which listing ---------- */
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="mailto:"]');
    if (!a || !root.contains(a)) return;
    var to = a.getAttribute('href').replace(/^mailto:/, '').split('?')[0] || 'hello@passionforfashion.au';
    var title = root.getAttribute('data-pff-title') || document.title;
    var id = root.getAttribute('data-product-id');
    var url = root.getAttribute('data-pff-url') || location.href.split('?')[0];
    var d = root.querySelector('#izyrent input.izyDate:not([type=hidden])') || document.getElementById('startDate');
    var dates = d && d.value ? d.value : '';
    var subj = 'Question about ' + title + ' (listing #' + id + ')';
    var body = 'Hi PFF,\n\n\n\n---\nListing: ' + title + '\nListing #: ' + id + '\nLink: ' + url + (dates ? '\nDates selected: ' + dates : '');
    a.setAttribute('href', 'mailto:' + to + '?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body));
  }, true);
  /* ---------- ask a question ---------- */
  var ask = root.querySelector('.pff-ask-form');
  if (ask) {
    var body = ask.querySelector('textarea');
    var warn = ask.querySelector('[data-pff-ask-warn]');
    $$('.pff-chips button', ask).forEach(function (c) {
      c.addEventListener('click', function () { body.value = (body.value ? body.value + '\n' : '') + c.textContent; body.focus(); });
    });
    var re = /(\b\d[\d\s-]{7,}\d\b)|([\w.+-]+@[\w-]+\.[\w.]+)|(@[a-z0-9_.]{3,})|(instagram|insta\b|whatsapp|facebook|\bfb\b)/i;
    if (body && warn) body.addEventListener('input', function () { warn.hidden = !re.test(body.value); });
    if (root.querySelector('[data-pff-ask-success]') || ask.querySelector('.pff-err') || /contact_posted=true/.test(location.search)) {
      openDialog(ask.closest('dialog'));
    }
  }
})();

/* r1793253063 */
